import {
    computeInfographic,
    InclusionContent,
    FareInfographic,
    infographicConifg,
    FareCardBaseContent,
} from "@silversea-ssc/ui-components-react"
import React, { useCallback } from "react"
import type { InclusionCode } from "@silversea-ssc/web-inclusions"
import type { CruiseGroupCode } from "@silversea-ssc/web-cruise-groups"
import type { TokenValues } from "@silversea-ssc/dotcom-read-model-types/Tokens"
import { t } from "@lingui/macro"
import useModal from "../../../../../components/ModalProvider/useModal"
import { useExpandableFareCard } from "../../../../../components/ExpandableFareCardProvider"
import { buildTabsContent } from "../../../../../components/InclusionsModal/utils"

interface InfographicProps {
    enabledInclusions: InclusionCode[]
    inclusionsContent: InclusionContent[]
    inclusionsContentTokens: TokenValues
    fareTitle: string
    cruiseGroup?: CruiseGroupCode
    className?: string
}

const newDefaultConfig = infographicConifg("default")
const newAntarcticaBridgeConfig = infographicConifg("antarcticaBridge")

const Infographic: React.FC<React.PropsWithChildren<InfographicProps>> = ({
    inclusionsContent,
    enabledInclusions,
    fareTitle,
    cruiseGroup,
    inclusionsContentTokens,
}) => {
    const { openModal } = useModal()
    const { isExpanded } = useExpandableFareCard()
    const config = cruiseGroup == "AntarcticaBridge" ? newAntarcticaBridgeConfig : newDefaultConfig
    const infographicSteps = computeInfographic(config, enabledInclusions, inclusionsContent, {
        cruise: t`all onboard luxury inclusions`,
        "pre-cruise": t`Pre Cruise Air & Transfer`,
        "post-cruise": t`Post Cruise Air & Transfer`,
        shorex: t`Shore Excursions`,
    })

    const onInclusionClick = useCallback(
        (stepsGroupId: string) => {
            openModal({
                modalType: "fare-inclusion",
                selectedStepGroupId: stepsGroupId,
                tabs: buildTabsContent(infographicSteps),
                fareTitle,
                inclusionsContentTokens,
            })
        },
        [fareTitle, inclusionsContentTokens, infographicSteps, openModal],
    )

    return (
        <React.Fragment>
            {isExpanded && (
                <FareCardBaseContent padding={"medium"}>
                    <FareInfographic
                        steps={infographicSteps}
                        expandable={true}
                        isExpanded={isExpanded}
                        variant="full-horizontal"
                        onInclusionClick={onInclusionClick}
                    />
                </FareCardBaseContent>
            )}
        </React.Fragment>
    )
}

export default Infographic
